// docs/plan/v0.4.0-parts-solution-defect-lot/plan.md §5.1
// S2 §9.3 (Phase 2.8) — 솔루션을 로봇 단위 → 매장 단위로 이동.

import type {
  SolutionCategory,
  SolutionStatus,
  SolutionDefSummaryDto,
  StoreSolutionDto,
  SolutionStoreUsageDto,
  CustomerSolutionRollupDto,
} from '@bhops/shared';
import { apiClient } from './client';

export interface ListSolutionsQuery {
  category?: SolutionCategory;
  status?: SolutionStatus;
  search?: string;
}

export const solutionsApi = {
  async list(query: ListSolutionsQuery = {}): Promise<SolutionDefSummaryDto[]> {
    const { data } = await apiClient.get<SolutionDefSummaryDto[]>('/solutions', {
      params: query,
    });
    return data;
  },
  async get(id: string): Promise<SolutionDefSummaryDto> {
    const { data } = await apiClient.get<SolutionDefSummaryDto>(`/solutions/${id}`);
    return data;
  },
  async listForStore(storeId: string): Promise<StoreSolutionDto[]> {
    const { data } = await apiClient.get<StoreSolutionDto[]>(`/stores/${storeId}/solutions`);
    return data;
  },

  // S2 §9.3 역추적 — 이 솔루션을 쓰는 매장 (S3 follow-up: 고객사/불판 포함).
  async storesForSolution(solutionDefId: string): Promise<SolutionStoreUsageDto[]> {
    const { data } = await apiClient.get<SolutionStoreUsageDto[]>(
      `/solutions/${solutionDefId}/stores`,
    );
    return data;
  },

  // S3 follow-up — 고객사별 매장 솔루션 rollup.
  async byCustomer(): Promise<CustomerSolutionRollupDto[]> {
    const { data } = await apiClient.get<CustomerSolutionRollupDto[]>('/solutions/by-customer');
    return data;
  },

  // ── Write (v0.4.0-beta) ────────────────────────────────────

  async create(body: {
    code: string;
    displayName: string;
    category: SolutionCategory;
    modelCompatibilityCodes?: string[];
    requiredPartCatalogIds?: string[];
    minBinaryVersion?: string;
    status?: SolutionStatus;
  }): Promise<SolutionDefSummaryDto> {
    const { data } = await apiClient.post<SolutionDefSummaryDto>('/solutions', body);
    return data;
  },

  async attachToStore(
    storeId: string,
    body: { solutionDefId: string; activatedAt?: string },
  ): Promise<StoreSolutionDto> {
    const { data } = await apiClient.post<StoreSolutionDto>(`/stores/${storeId}/solutions`, body);
    return data;
  },

  async deactivate(
    storeSolutionId: string,
    body: { deactivationReason: string; deactivatedAt?: string },
  ): Promise<StoreSolutionDto> {
    const { data } = await apiClient.patch<StoreSolutionDto>(
      `/store-solutions/${storeSolutionId}/deactivate`,
      body,
    );
    return data;
  },
};
